module.exports = require("babel-plugin-universal-import/universalImport");